var map = {
	"./24a9.webp": 94639,
	"./5b3e.webp": 52636,
	"./7ece.webp": 71815,
	"./93f3.webp": 19064,
	"./a1a2.webp": 85406,
	"./abstract-1.webp": 41687,
	"./abstract-10.webp": 15873,
	"./abstract-2.webp": 4310,
	"./abstract-3.webp": 77937,
	"./abstract-4.webp": 69368,
	"./abstract-5.webp": 45819,
	"./abstract-6.webp": 58970,
	"./abstract-7.webp": 30469,
	"./abstract-8.webp": 56204,
	"./abstract-9.webp": 13423,
	"./alice.webp": 44617,
	"./anime.webp": 78905,
	"./aurora-2.webp": 8248,
	"./aurora.webp": 93835,
	"./autumn.webp": 34801,
	"./aviator.webp": 67363,
	"./b909.webp": 79021,
	"./baroque.webp": 9090,
	"./bart.webp": 89008,
	"./beauty.webp": 32307,
	"./bubbles.webp": 89490,
	"./calmness.webp": 9883,
	"./candy.webp": 51560,
	"./canvas.webp": 55143,
	"./capri.webp": 82336,
	"./caribbean.webp": 91578,
	"./carnival.webp": 39221,
	"./ceremony.webp": 767,
	"./charles.webp": 5909,
	"./coffee.webp": 60559,
	"./colorful.webp": 86065,
	"./comic.webp": 85072,
	"./cordeville.webp": 38378,
	"./crinkle.webp": 75317,
	"./cubism.webp": 19574,
	"./daily.webp": 95288,
	"./dark.webp": 63419,
	"./dawn.webp": 17457,
	"./dd4e.webp": 90672,
	"./dd87.webp": 81678,
	"./discofever.webp": 11451,
	"./dotty.webp": 2345,
	"./dreamworld.webp": 31834,
	"./eagle.webp": 69241,
	"./elegant-silence.webp": 90477,
	"./elisabeth.webp": 83988,
	"./epoch.webp": 67496,
	"./explosion.webp": 55646,
	"./expressionism.webp": 69464,
	"./eye.webp": 28300,
	"./fairy.webp": 92488,
	"./fantasy.webp": 17347,
	"./feast.webp": 52030,
	"./forelock.webp": 4554,
	"./forward.webp": 59328,
	"./ghibli-studio.webp": 53905,
	"./gothic.webp": 11873,
	"./grace.webp": 41221,
	"./illustration.webp": 54741,
	"./impressionism-1.webp": 85947,
	"./impressionism-2.webp": 63578,
	"./iridescent.webp": 3311,
	"./joke.webp": 6896,
	"./landscape.webp": 32360,
	"./luminous.webp": 34297,
	"./madison.webp": 62146,
	"./manga.webp": 17577,
	"./mediterranean.webp": 88602,
	"./mixture.webp": 35733,
	"./modern-art-1.webp": 77102,
	"./modern-art-2.webp": 9551,
	"./modern-art-3.webp": 52460,
	"./modern-art-4.webp": 73533,
	"./modern-art-5.webp": 70770,
	"./modern-art-6.webp": 1491,
	"./moonlight.webp": 80538,
	"./mosaic-1.webp": 97149,
	"./mosaic-2.webp": 54320,
	"./mosaic-3.webp": 80083,
	"./mudita.webp": 14033,
	"./newspaper.webp": 25982,
	"./ocean.webp": 71823,
	"./oil-painting.webp": 17624,
	"./patterns.webp": 51912,
	"./pencil.webp": 60142,
	"./petals.webp": 44006,
	"./photography.webp": 53582,
	"./pixel-art.webp": 45925,
	"./pointillism-1.webp": 42971,
	"./pointillism-2.webp": 56122,
	"./pointillism-3.webp": 27621,
	"./pop-art.webp": 10706,
	"./pop.webp": 32930,
	"./poppy.webp": 92389,
	"./promenade.webp": 42098,
	"./retro.webp": 31017,
	"./satisfaction.webp": 46947,
	"./sixties.webp": 81222,
	"./sketch-1.webp": 97109,
	"./sketch-2.webp": 97352,
	"./sketch-3.webp": 94731,
	"./sketchy.webp": 24378,
	"./snow.webp": 2800,
	"./summer.webp": 12078,
	"./sunny.webp": 34622,
	"./surrealism-1.webp": 75472,
	"./surrealism-2.webp": 84125,
	"./surrealism-3.webp": 40562,
	"./tears.webp": 34936,
	"./ukiyo-e.webp": 46476,
	"./urban.webp": 53485,
	"./voyage.webp": 74670,
	"./waterbird.webp": 30257,
	"./watercolor-1.webp": 36867,
	"./watercolor-2.webp": 71970,
	"./wolf.webp": 94459,
	"./yira.webp": 14436,
	"./zinaida.webp": 90761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38639;